var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import observer from 'src/shared/decorators/observer';
var NotFound = /** @class */ (function (_super) {
    __extends(NotFound, _super);
    function NotFound() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotFound.prototype.componentWillMount = function () {
        document.body.className = '';
    };
    NotFound.prototype.render = function () {
        require('./404.css');
        return (React.createElement("div", null,
            React.createElement("div", { id: "notfound" },
                React.createElement("div", { className: "notfound" },
                    React.createElement("div", { className: "notfound-404" },
                        React.createElement("h1", null, ":(")),
                    React.createElement("h2", null, "404 - Sayfa bulunamad\u0131"),
                    React.createElement("p", null, "Arad\u0131\u011F\u0131n\u0131z sayfan\u0131n ad\u0131 de\u011Fi\u015Ftirilmi\u015F veya ge\u00E7ici olarak kullan\u0131lam\u0131yor olabilir."),
                    React.createElement("a", { href: "/" }, "Anasayfa")))));
    };
    NotFound = __decorate([
        observer
    ], NotFound);
    return NotFound;
}(React.Component));
export default NotFound;



//////////////////
// WEBPACK FOOTER
// ./src/app/core/404.tsx
// module id = 1603
// module chunks = 0